const timesRefresh =
  typeof process.env.VUE_APP_TIMES_REFRESH === 'string'
    ? parseInt(process.env.VUE_APP_TIMES_REFRESH) || 300000 // five minutes
    : process.env.VUE_APP_TIMES_REFRESH || 300000; // five minutes

export enum RefreshTime {
  TIMES = timesRefresh,
}
